import { render } from "./MessageIndex.vue?vue&type=template&id=402b21d0&scoped=true"
import script from "./MessageIndex.vue?vue&type=script&lang=js"
export * from "./MessageIndex.vue?vue&type=script&lang=js"

import "./MessageIndex.vue?vue&type=style&index=0&id=402b21d0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402b21d0"]])

export default __exports__